import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[capClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output()
  public capClickOutside = new EventEmitter<any>();

  constructor(private _elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);

    if (!clickedInside) {
      this.capClickOutside.emit(targetElement);
    }
  }
}
